import React from "react";

interface NavLink {
  id: string;
  label: string;
}

interface WeddingLayoutProps {
  children: React.ReactNode;
  photoUrl: string;
  photoAlt: string;
  date?: string;
  activeTab?: string;
  onTabChange?: (tab: string) => void;
  customNavLinks?: NavLink[];
}

const WeddingLayout: React.FC<WeddingLayoutProps> = ({
  children,
  photoUrl,
  photoAlt,
  date = "Sept. 18th, 2025",
  activeTab = "rsvp",
  onTabChange,
  customNavLinks,
}) => {
  const defaultNavLinks = [
    { id: "rsvp", label: "RSVP" },
    { id: "registry", label: "Registry" },
    { id: "faqs", label: "FAQs" },
  ];

  const navLinks = customNavLinks || defaultNavLinks;

  const handleTabClick = (tabId: string) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  const shouldFrame = customNavLinks ? true : activeTab !== "registry";

  return (
    <div className="wedding-container">
      {/* Date Bar */}
      <div className="date-bar wedding-serif">{date}</div>

      {/* Sticky Navigation */}
      <div className="wedding-nav">
        {navLinks.map((link) => (
          <span
            key={link.id}
            onClick={() => handleTabClick(link.id)}
            className={`wedding-nav-link ${
              activeTab === link.id ? "active" : ""
            }`}
          >
            {link.label}
          </span>
        ))}
      </div>

      {photoUrl && (
        <div className="photo-section">
          <img src={photoUrl} alt={photoAlt} />
        </div>
      )}

      {/* Framed Section */}
      <div className={shouldFrame ? "framed-section" : ""}>{children}</div>
    </div>
  );
};

export default WeddingLayout;
